<template>
    <section class="sobre" id="sobre">

        <div class="bg1">
            <div class="container">

                <div class="row">

                    <div class="d-md-block col-md-4 offset-md-2">
                        <h2>
                            <small>sobre</small><br>
                            Carlos<br>
                            Humberto
                        </h2>
                    </div>

                    <div class="col-md-4">
                        <img src="images/carlos.png" id="foto-carlos" />
                    </div>

                </div>

            </div>
        </div>

        <div class="bg2">
            <div class="container">

                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div :class="{ 'abre-fecha' : true, 'fechado': !aberto }">
                            <img src="images/linha-do-tempo.png" />
                        </div>
                    </div>
                </div>

            </div>

            <div class="degrade" v-show="!aberto">
                <button @click="clic">Clique aqui para expandir</button>
            </div>
        </div>

    </section>
</template>
<script>
export default {
    
     data() {
        return {
            aberto:  false
        }
    },

    methods: {

        clic: function(){
            this.aberto = (!this.aberto);
        }

    }

}
</script>


<style lang="less" scoped>
    @import "@less/vars.less";
    @import "@less/base.less";

    h2{
        color: @cor-azul;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 45px;
        margin: 200px 0;

        @media (max-width: 575.98px){
            margin-top: 50px;
            margin-bottom: 0;
            margin-left: 25px;
        }

        small{
            font-weight: 400;
            font-size: 30px;
        }
    }

    #foto-carlos{
        margin: 50px 0;
    }
</style>